import React from 'react'
import PropTypes from 'prop-types'
import './LastStep.sass'

const LastStep = ({
  lastStepCaption ,
  lastStepInfo ,
  color
}) => (
  <ul className={`lastStep ${color}`}>
    <li className="lastStep__caption"><span />
      {lastStepCaption && lastStepCaption}
    </li>
    <li className="lastStep__content">
      {lastStepInfo && lastStepInfo}
    </li>
  </ul>
)

LastStep.propTypes = {
  lastStepCaption: PropTypes.string.isRequired,
  lastStepInfo: PropTypes.string.isRequired,
  color: PropTypes.string
}

LastStep.defaultProps = {
  color: 'primary'
}

export default LastStep



// WEBPACK FOOTER //
// ./components/Service_LastStep/index.jsx